//import { checkTokenExists, setToken } from '../helpers/auth';
import api from './api';
import localforage from "localforage";

export const SET_LOCATIONS = 'SET_LOCATIONS';
export const ADD_LOCATION = 'ADD_LOCATION';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const REMOVE_LOCATION = 'REMOVE_LOCATION';

export const getLocations = (company) => async dispatch => {
    if (window.navigator.onLine) {
        return window.axios.get(api.locations.index.replace(':company', company.id))
            .then(async (response) => {
                dispatch(setLocations(company, response.data.locations));

                return Promise.resolve({ ...response.data });
            })
            .catch(error => {
                return Promise.reject(error)
            });
    } else {
        try {
            await localforage.setDriver(localforage.INDEXEDDB);

            const locations = await localforage.getItem('bs_locations_' + company.id);
            if (locations) {
                dispatch(setLocations(company, locations));
            }

            return Promise.resolve({ ...locations });

        } catch (e) {
            return Promise.reject(e);
        }

    }
};

export const createLocation = (company, data) => dispatch => {
  return window.axios.post(api.locations.store.replace(':company', company.id), data)
        .then((response) => {
          dispatch(addLocation(company, response.data.location));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const editLocation = (company, location, data) => dispatch => {
  data['_method'] = 'PATCH';
  return window.axios.post(api.locations.update.replace(':location', location.id), data)
        .then((response) => {
          dispatch(updateLocation(company, response.data.location));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const deleteLocation = (location) => dispatch => {
  let data = {};
  data['_method'] = 'DELETE';
  return window.axios.post(api.locations.destroy.replace(':location', location.id), data)
        .then((response) => {
          dispatch(removeLocation(location));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const setLocations = (company, locations) => ({
  type: SET_LOCATIONS,
  company, 
  locations
});

export const addLocation = (company, location) => ({
  type: ADD_LOCATION,
  company,
  location
});

export const updateLocation = (company, location) => ({
  type: UPDATE_LOCATION,
  company,
  location
});

export const removeLocation = (location) => ({
  type: REMOVE_LOCATION,
  location
});